// Mui
import { styled } from "@mui/material"

// Config
import { drawerWidth } from "src/configs/themeConfig"

// ------------------------------------|| MAIN STYLED - COMPONENTS ||-------------------------------------------------------

export const StyledMain = styled("main", { shouldForwardProp: prop => prop !== "open" })(({ theme, open }) => ({
  minHeight: `calc(100vh - 188px)`,
  width: `calc(100% - ${drawerWidth}px)`,
  flexGrow: 1,
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen
  }),
  [theme.breakpoints.down("md")]: {
    paddingLeft: 0
  },
  ...(open && {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen
    })
  })
}))
